export default "__VITE_PUBLIC_ASSET__001c6925__"